import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { useMetricsContext } from 'modules/productAnalytics/context';
import { useMemo } from 'react';
import { MetricsTableContainer } from './MetricsTable.styled';
import { getCrossMediumTableData } from './MetricsTable.utils';
import { MetricsTableBody } from './MetricsTableBody';
import { MetricsTableHeader } from './MetricsTableHeader';
import { METRICS_TABLE_TEST_IDS } from './MetricsTable.constants';

export const MetricsTable = () => {
  const { highLevelMetrics } = useMetricsContext();
  const {
    campaignsHealthMetricsQuery: {
      metrics: { perMediumMetricsAggregations = {} } = {},
    },
  } = useMissionControlContext();

  const allTableData = useMemo(
    () => getCrossMediumTableData(perMediumMetricsAggregations, highLevelMetrics),
    [perMediumMetricsAggregations, highLevelMetrics],
  );

  return (
    <MetricsTableContainer role="table" data-test={METRICS_TABLE_TEST_IDS.TABLE}>
      <MetricsTableHeader allTableData={allTableData} />
      <MetricsTableBody allTableData={allTableData} />
    </MetricsTableContainer>
  );
};
